// Aceita vazio (campo opcional; `required` é checado à parte),
// URL absoluta http(s) ou caminho iniciando com "/".
export const urlOrPath = (value) => {
  if (!value) return true
  if (value.startsWith('/')) return true

  return /^https?:\/\/.+/i.test(value)
}

// Aceita vazio (campo opcional; `required` é checado à parte).
// Exige caminho começando com "/blog/" seguido de conteúdo (ex.: /blog/redirect-1234).
export const blogPath = (value) => {
  if (!value) return true

  return /^\/blog\/.+/.test(value)
}
